<template>
  <div v-if="entriesWithoutWarnings.length > 0">
    <div class="sidebar-list-block sidebar-list-block-title theme-list-title">
      <div class="db-100 sidebar-list-title">{{ group.tagGroupName }} <i class="lni lni-chevron-up"></i></div>
    </div>
    <div class="results-container">
      <input
        type="text"
        v-model="searchQuery"
        placeholder="Αναζήτηση"
        class="search-input"
        :class="{ 'search-input-error': hasNoResults }"
        v-if="entriesWithoutWarnings.length > maxEntries"
      >
      <div :class="getTagEntriesClassName">
        <EntryFilter
          v-for="(tagEntry, _index) in visibleEntries"
          :key="tagEntry.id"
          :entry="tagEntry"
          :group="group"
          class="tag-listing-filters-tag-entry"
        >
        </EntryFilter>
      </div>
      <div v-if="entriesWithoutWarnings.length > maxEntries" class="group-filter-see-more">
        <button type="button" class="group-filter-see-more-button" @click="toggleShowAll">
          {{ showAllEntries ? 'Δες λιγότερα' : 'Δες περισσότερα' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  props: {
    group: Object,
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showAllEntries: false,
      maxEntries: 5,
      searchQuery: ''
    }
  },
  computed: {
    entriesWithoutWarnings() {
      return this.entries.filter(entry => !entry.tagWarning)
    },
    getTagEntriesClassName() {
      let className = ''
      className += this.group.tagDisplayType
      return className
    },
    filteredEntries() {
      if (!this.searchQuery || this.searchQuery.length < 3) {
        return this.entriesWithoutWarnings
      }
      const normalizedSearchQuery = this.normalizeGreekText(this.searchQuery.toLowerCase())
      return this.entriesWithoutWarnings.filter(entry => {
        const entryTextNormalized = this.normalizeGreekText(entry.tagName.toLowerCase())
        return entryTextNormalized.includes(normalizedSearchQuery)
      })
    },
    visibleEntries() {
      return this.showAllEntries ? this.filteredEntries : this.filteredEntries.slice(0, this.maxEntries)
    },
    hasNoResults() {
      return this.searchQuery.length >= 3 && this.filteredEntries.length === 0
    }
  },
  methods: {
    normalizeGreekText(text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    toggleShowAll() {
      this.showAllEntries = !this.showAllEntries
    }
  }
}
</script>

<style lang="scss" scoped>

.theme-list-title {
  margin-top: 15px
}

.group-filter-see-more {
  width: 100%;
  border-bottom: 1px solid #707070;
  padding-bottom: 10px;
  padding-top: 10px
}

.group-filter-see-more-button {
  color: #231f20;
  font-size: 14px;
  font-weight: 700;
  background: unset;
  border: unset;
  padding: 0;
}

.search-input {
  border: 1px solid #231f20;
  border-radius: unset;
  color: #231f20;
  font-size: 13px;
  font-weight: 400;
  height: 35px;
  padding: 10px;
  width: 100%;
  margin-bottom: 1rem;
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
  &.search-input-error {
    border-color: #D2232A;
  }
  &:active, &:focus {
    outline: none;
  }
}

.text {
  display: flex;
  flex-direction: column;
  max-height: 150px;
  overflow-y: auto;
}

.results-container {
  display: flex;
  flex-direction: column;
}
</style>
